<template>
  <div class="mt-5 p-5 text-center">
    <div class="h1">
      <i
        v-if="!app.id"
        class="fa fa-fw fa-lock"
      />
      <i
        v-if="app.id"
        class="fa fa-fw fa-unlock animated bounceIn"
      />
    </div>
    <div class="mb-3">
      <b v-html="status"></b>
    </div>
    <div class="mb-5">
      <div class="h2">
        <i
          v-if="loading || app.id"
          class="fa fa-fw fa-circle-o-notch fa-spin"
        />
        <div
          v-if="error"
          class="text-danger mb-5"
        >
          <i class="fa fa-fw fa-close animated bounceIn" />
        </div>
      </div>
      <div v-if="error">
        <p class="mb-3">
          {{ error }}
        </p>
        <a :href="homeUrl" class="btn btn-white">
          <i class="fa fa-home mr-1" />
          Go Home
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { getApp } from '@/api'
import { MessageBag } from '@/lib/MessageBag'

export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    connection: {
      type: String,
      default: null
    },
    homeUrl: {
      type: String,
      default: '/'
    },
    action: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      app: {},
      error: null
    }
  },
  watch: {
    app () {
      // TODO: update page title
    }
  },
  computed: {
    status () {
      if (this.app.id) {
        return this.app.name
      } else if (this.error) {
        return 'Error'
      } else {
        return 'Accessing...'
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.loadApp()
    }, 1000)
  },
  methods: {
    async loadApp () {
      try {
        let response = await getApp(this.id, this.connection)
        this.app = response.data.app
        if (this.action === 'login') {
          document.location.replace(response.data.loginUrl)
        } else if (this.action === 'edit') {
          document.location.replace(response.data.editUrl)
        } else {
          this.app = null
          this.error = `Unknown SSO action: ${this.action}`
        }
      } catch (error) {
        if (error.response.status === 404) {
          this.error = 'This app does not exist.'
        } else if (error.response.status === 403) {
          this.error = 'You are not authorized to log into this app.'
        } else if (error.response.status === 422) {
          this.error = MessageBag.fromResponse(error).first()
        } else {
          this.error = error
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>